import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Modal from '../../../components/Modal'
import {VarianceModal} from './performance_items/Variance'
import {DarkDaysModal} from './performance_items/DarkDays'
import {FrequencyModal} from './performance_items/Frequency'
import {CpmModal} from './performance_items/Cpm'
import {CpcModal} from './performance_items/Cpc'
import {CtrModal} from './performance_items/Ctr'
import {YoyModal} from './performance_items/Yoy'
import {UserCountModal} from './performance_items/UserCount'

class PerformanceItemModal extends Component {
	modals = {
		variance: VarianceModal,
		darkDays: DarkDaysModal,
		frequency: FrequencyModal,
		cpm: CpmModal,
		cpc: CpcModal,
		ctr: CtrModal,
		yoy: YoyModal,
		users: UserCountModal
	}

	renderSubscribeModal = (subscribed, clicked) => {
		if(!subscribed) {
			return (
				<button className="cta" type="button" onClick={clicked}>Monitor My Score For Free</button>
			)
		} else {
			return (<span></span>)
		}
	}

	render() {
		const { display, type, modalDismissed, subscribed, subscribeButtonClicked } = this.props
		const TagName = this.modals[type || 'variance']
		return (
			<Modal display={display} modalDismissed={modalDismissed}>
				<Fragment>
					<TagName />
					{this.renderSubscribeModal(subscribed, subscribeButtonClicked)}
				</Fragment>
			</Modal>
		)
	}
}

PerformanceItemModal.propTypes = {
	display: PropTypes.bool.isRequired,
	type: PropTypes.string.isRequired,
	modalDismissed: PropTypes.func.isRequired,
	subscribeButtonClicked: PropTypes.func.isRequired,
	subscribed: PropTypes.bool.isRequired
}

export default PerformanceItemModal


// WEBPACK FOOTER //
// ./src/containers/ReportLoaderTopLeads/components/PerformanceItemModal.js